import { useMemo } from "react";
import { useQueries } from "@tanstack/react-query";
import { useToken } from "@bn/api";
import { CACHE_KEYS, getPrivateNotes } from "@bn/api/apiv1";

export const useInvestmentPrivateNotesMap = (
  investmentIds: number[]
): Record<number, string | undefined> => {
  const { data: token } = useToken();
  const accessToken = token?.access_token;

  const uniqueIds = useMemo(
    () => Array.from(new Set(investmentIds)),
    [investmentIds]
  );

  const results = useQueries({
    queries: uniqueIds.map((id) => ({
      queryKey: [CACHE_KEYS.GET_PRIVATE_NOTES, { id }, accessToken],
      queryFn: () => getPrivateNotes(accessToken, { id }),
      enabled: Boolean(accessToken),
    })),
  });

  return useMemo(() => {
    const map: Record<number, string | undefined> = {};
    uniqueIds.forEach((id, i) => {
      const comment = results[i]?.data?.comment;
      map[id] = comment ? comment : undefined;
    });
    return map;
  }, [uniqueIds, results]);
};
